import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { UserVehicleContext } from '~/context/vdp/UserVehicleContext';
import { useAvailabilityForAnalytics } from '../useAvailabilityForAnalytics';

export default function useSendAvailabilityData() {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    vehicleAvailability: { isLoaded }
  } = useContext(UserVehicleContext);
  const availabilityEventData = useAvailabilityForAnalytics();

  useEffectOnce(
    () => {
      trackEvent('Availability data', { availabilityEventData });
    },
    [availabilityEventData, trackEvent],
    isLoaded
  );
}
